import React from 'react';
import { has, pathEq, complement, sortWith, descend, compose, path, dissocPath } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';

import { formatDate, dateValue, editTimeLeft } from 'lib/dateDisplay';
import { getAllCommitsData } from 'lib/documentHandling';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';
import moment from 'moment';

const msg = id => ({ id });

const isActive = complement(pathEq(['content', 'hasEnded'], true));

export const sorter = sortWith([descend(isActive), descend(compose(dateValue, path(['content', 'start'])))]);

const formatHeader = (fields, fm, rehab8Finished) =>
  rehab8Finished
    ? `${fm({ id: 'onlineRehabilitation.history.finished' })}`
    : has('cancelled', fields) && fields.cancelled === true
      ? `${fm({ id: 'onlineRehabilitation.history.cancelled' })}`
      : `${fm({ id: 'onlineRehabilitation.history.started' })}`;

// Data for new commit, neurologistsComments and answerFromNeurologist omitted so that the patient
// doesn't change them
const newEditingData = doc => {
  const omitCommentsRehab3 = dissocPath(['rehab3', 'neurologistsComments'], getAllCommitsData(doc));
  const omitCommentsRehab4 = dissocPath(['rehab4', 'answerFromNeurologist'], omitCommentsRehab3);
  const omitCommentsRehab5 = dissocPath(['rehab5', 'neurologistsComments'], omitCommentsRehab4);
  const omitCommentsRehab6 = dissocPath(['rehab6', 'answerFromNeurologist'], omitCommentsRehab5);
  return omitCommentsRehab6;
};

const historyMapper =
  (name, edit, view) =>
  (d, { formatMessage }) => {
    const cancelled = !!d.content.cancelled;

    const rehab8Finished = path(['content', 'rehab8', 'finished'], d);

    const timeLeft = editTimeLeft(moment.utc(rehab8Finished).valueOf());

    return (
      <HistoryEntry key={d.documentId}>
        <HistoryEntryHeader title={formatHeader(d.content, formatMessage, rehab8Finished)} active={!cancelled}>
          {!cancelled && timeLeft && (
            <CommonHistoryEntryControls
              time={rehab8Finished && moment.utc(rehab8Finished).valueOf()}
              action={() => edit(d.documentType, d.documentId, newEditingData(d))}
            />
          )}
          {rehab8Finished && !timeLeft && <CommonViewButton onView={e => view(d.documentId)} />}
        </HistoryEntryHeader>
        <HistoryEntryColumns>
          {rehab8Finished ? (
            <div>
              <HistoryEntryColumn header={formatMessage(msg('onlineRehabilitation.history.date'))}>
                <p>
                  {formatDate(d.content.start)} - {formatDate(moment.utc(rehab8Finished).valueOf())}
                </p>
              </HistoryEntryColumn>
            </div>
          ) : cancelled ? (
            <HistoryEntryColumn header={formatMessage(msg('onlineRehabilitation.history.date'))}>
              <p>{formatDate(d.lastCommitTime)}</p>
            </HistoryEntryColumn>
          ) : (
            <HistoryEntryColumn header={formatMessage(msg('onlineRehabilitation.history.startDate'))}>
              <p>{formatDate(d.content.start)}</p>
            </HistoryEntryColumn>
          )}
        </HistoryEntryColumns>
      </HistoryEntry>
    );
  };

export default historyMapper;
